
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ffubonzxmesemzxlrwbp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZmdWJvbnp4bWVzZW16eGxyd2JwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5MDAyNjgsImV4cCI6MjA1NzQ3NjI2OH0.SzUQFV9M218onIGVjtVWnYDz445-PIJbL5E6du0ZLpg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'supabase.auth.token',
      detectSessionInUrl: true,
      flowType: 'pkce',
      debug: true  // Enable debug mode to help diagnose authentication issues
    },
    // Enable better error reporting for large requests
    db: {
      schema: 'public'
    },
    global: {
      headers: {
        'X-Client-Info': 'promptsAdmin'
      }
    }
  }
);

// Add debug event listener for auth state changes in development
supabase.auth.onAuthStateChange((event, session) => {
  console.log(`Supabase Auth Event: ${event}`, session ? {
    userId: session.user?.id,
    email: session.user?.email,
    hasSession: true,
    provider: session.user?.app_metadata?.provider,
    createdAt: session.user?.created_at,
    lastSignIn: session.user?.last_sign_in_at
  } : 'No session');
});

/**
 * Get the callback URL for authentication redirects
 * This ensures consistent redirect URLs across the application
 */
export const getAuthRedirectUrl = (type: 'signup' | 'signin' | 'recovery' = 'signup'): string => {
  // Use window.location.origin to get the base URL of the current environment
  const baseUrl = window.location.origin;
  return `${baseUrl}/auth/callback?type=${type}`;
};
